import React from "react";

export default function StarDark(props) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.65416 1.06438C8.76302 0.72936 9.23698 0.72936 9.34584 1.06438L11.1635 6.65856C11.2122 6.80839 11.3518 6.90983 11.5093 6.90983H17.3914C17.7437 6.90983 17.8901 7.3606 17.6051 7.56765L12.8465 11.025C12.719 11.1176 12.6657 11.2818 12.7144 11.4316L14.532 17.0258C14.6409 17.3608 14.2574 17.6394 13.9724 17.4323L9.21374 13.975C9.08629 13.8824 8.91371 13.8824 8.78626 13.975L4.02757 17.4323C3.74258 17.6394 3.35913 17.3608 3.46799 17.0258L5.28565 11.4316C5.33433 11.2818 5.281 11.1176 5.15355 11.025L0.394853 7.56765C0.109866 7.3606 0.25633 6.90983 0.608593 6.90983H6.49066C6.6482 6.90983 6.78782 6.80839 6.8365 6.65856L8.65416 1.06438Z"
        fill="#CBD5E1"
      />
    </svg>
  );
}
